<template>
    <div class="led_box animate__animated animate__fadeIn">
        <div class="led">
            <!-- 环境监测详情 -->
            <div class="content_box">
                <div class="content_title">
                    <div class="search-btn orange" style="float: right;margin: 12px 50px 0 0;width: 200px"
                        @click="fnUpload"><span>上传至重庆市建委平台</span></div>
                </div>
                <div class="content">
                    <div class="content_tab">
                        <el-tabs v-model="activeName" type="border-card">

                            <el-tab-pane label="人脸识别基础数据" name="access">
                                <sTabPane :data="access" :dataConfig="accessConfig.config">
                                </sTabPane>
                            </el-tab-pane>

                            <el-tab-pane label="视频监控基础数据" name="monitor">
                                <sTabPane :data="monitor" :dataConfig="monitorConfig.config">
                                </sTabPane>
                            </el-tab-pane>

                            <el-tab-pane label="环境监测基础数据" name="env">
                                <sTabPane :data="env" :dataConfig="envConfig.config">
                                </sTabPane>
                            </el-tab-pane>
                            <el-tab-pane label="塔吊监测基础信息" name="crane">
                                <div class="location"><a href="https://lbs.amap.com/console/show/picker"
                                        target="_blank">点击拾取坐标</a></div>
                                <sTabPane :data="crane" :dataConfig="craneConfig.config">
                                </sTabPane>
                            </el-tab-pane>

                            <el-tab-pane label="升降机监测基础信息" name="elevator">
                                <div class="location"><a href="https://lbs.amap.com/console/show/picker"
                                        target="_blank">点击拾取坐标</a></div>
                                <sTabPane :data="elevator" :dataConfig="elevatorConfig.config"></sTabPane>
                            </el-tab-pane>

                            <el-tab-pane label="卸料平台监测基础信息" name="unloading">
                                <sTabPane :data="unloading" :dataConfig="unloadingConfig.config"></sTabPane>
                            </el-tab-pane>

                            <el-tab-pane label="AI监测基础数据" name="helmet">
                                <sTabPane :data="helmet" :dataConfig="helmetConfig.config">
                                </sTabPane>
                            </el-tab-pane>

                            <el-tab-pane label="人员安全帽GPS定位信息" name="pushGPSLocationInfo">
                                <div style="color: #f56c6c;">带*必填</div>
                                <div class="location"><a href="https://lbs.amap.com/console/show/picker"
                                        target="_blank">点击拾取坐标</a></div>
                                <sTabPane :data="pushGPSLocationInfo" :dataConfig="pushGPSLocationInfoConfig.config">
                                </sTabPane>
                            </el-tab-pane>

                            <el-tab-pane label="人员定位底图信息" name="pushLocationMap">
                                <div style="color: #f56c6c;">带*必填</div>
                                <sTabPane :data="pushLocationMap" :dataConfig="pushLocationMapConfig.config">
                                </sTabPane>
                            </el-tab-pane>

                            <el-tab-pane label="人员定位信息" name="pushXYZLocation">
                                <div style="color: #f56c6c;">带*必填</div>
                                <sTabPane :data="pushXYZLocation" :dataConfig="pushXYZLocationConfig.config">
                                </sTabPane>
                            </el-tab-pane>

                            <el-tab-pane label="车辆未冲洗检测抓拍信息" name="pushVehiclewashinfo">
                                <div style="color: #f56c6c;">带*必填</div>
                                <sTabPane :data="pushVehiclewashinfo" :dataConfig="pushVehiclewashinfoConfig.config">
                                </sTabPane>
                            </el-tab-pane>

                            <el-tab-pane label="风险分级信息" name="pushRiskLevel">
                                <div style="color: #f56c6c;">带*必填</div>
                                <sTabPane :data="pushRiskLevel" :dataConfig="pushRiskLevelConfig.config">
                                </sTabPane>
                            </el-tab-pane>

                            <el-tab-pane label="安全自检信息" name="pushSafetySelfCheck">
                                <div style="color: #f56c6c;">带*必填</div>
                                <sTabPane :data="pushSafetySelfCheck" :dataConfig="pushSafetySelfCheckConfig.config">
                                </sTabPane>
                            </el-tab-pane>

                            <el-tab-pane label="工程验收信息" name="pushAcceptanceOfWorks">
                                <div style="color: #f56c6c;">带*必填</div>
                                <div class="location"><a href="https://xingzhengquhua.bmcx.com/"
                                        target="_blank">点击查询区划代码</a></div>
                                <sTabPane :data="pushAcceptanceOfWorks"
                                    :dataConfig="pushAcceptanceOfWorksConfig.config">
                                </sTabPane>
                            </el-tab-pane>

                        </el-tabs>
                    </div>
                </div>
            </div>
        </div>

        <div class="dialog_choose" v-if="showUpload">
            <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="上传进度" top="20vh" center
                :visible.sync="showUpload" @close="fnUploadFinish">
                <div class="line_item">
                    <span>上传中：{{ uploading }};</span>
                    <span>上传成功：{{ upload_successful }};</span>
                    <span>上传失败：{{ upload_failure }}。</span>
                </div>
                <div class="cont_list">
                    <div class="list_title">
                        <div class="title_item">上传名称</div>
                        <div class="title_item">状态</div>
                        <div class="title_item">详情</div>
                    </div>
                    <div class="list_boxes">
                        <div class="list_box">
                            <div class="box_line" v-for="(item, index) in uploadList" :key="index">
                                <div class="list_item">{{ item.name }}</div>
                                <div class="list_item">
                                    <span v-if="item.result == 1">上传中</span>
                                    <span v-else-if="item.result == 2">上传成功</span>
                                    <span v-else style="color: #C03639">上传失败</span>
                                </div>
                                <p class="list_item" :title="item.details"
                                    style="overflow:hidden; white-space:nowrap; justify-content: normal;">
                                    {{ item.details }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer" align="center">
                    <div class="btn_line">
                        <div class="search-btn" @click="fnUploadFinish"><span>确定</span></div>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import request from '@/utils/request';
    import sTabPane from '@/components/s-tab-pane';
    import {
        fnRequestPlatform
    } from '@/utils/upload';
    export default {
        components: {
            sTabPane
        },
        data() {
            let baseRadio = {
                0: '未配置',
                1: '已配置'
            }; // 默认单选配置
            return {
                activeName: 'access', // 默认选中tab
                editId: '', // 编辑id

                access: [{
                    deviceSN: '', // 设备序列号
                    deviceID: '', // 设备 ID
                }], // 人脸识别基础数据
                accessConfig: {
                    name: '人脸识别基础数据',
                    url: '',
                    config: {
                        deviceSN: {
                            type: 0,
                            name: '设备序列号',
                            parameter: '请输入设备序列号'
                        },
                        deviceID: {
                            type: 0,
                            name: '设备 ID',
                            parameter: '请输入建委设备ID'
                        },
                    } // type 0输入框 1单选 2下拉
                },

                monitor: [{
                    deviceSN: '', // 设备序列号
                    deviceID: '', // 设备 ID
                }], // 视频监控基础数据
                monitorConfig: {
                    name: '视频监控基础数据',
                    url: '',
                    config: {
                        deviceSN: {
                            type: 0,
                            name: '设备序列号',
                            parameter: '请输入设备序列号'
                        },
                        deviceID: {
                            type: 0,
                            name: '设备 ID',
                            parameter: '请输入建委设备ID'
                        },
                    } // type 0输入框 1单选 2下拉
                },

                env: [{
                    deviceSN: '', // 设备序列号
                    deviceID: '', // 设备 ID
                    monitorPoints: '', // 	监测点位
                }], // 环境监测设备定位数据
                envConfig: {
                    name: '环境监测设备基础数据',
                    url: '',
                    config: {
                        deviceSN: {
                            type: 0,
                            name: '设备序列号',
                            parameter: '请输入设备序列号'
                        },
                        deviceID: {
                            type: 0,
                            name: '设备 ID',
                            parameter: '请输入建委设备ID'
                        },
                        monitorPoints: {
                            type: 0,
                            name: '监测点位',
                            parameter: '废气、废水必填'
                        },
                    } // type 0输入框 1单选 2下拉
                },

                crane: [{
                    deviceSN: '', // C50是设备序列号
                    deviceID: '', // C50是设备ID
                    craneType: '0', // C1是塔机类型0: 动臂吊1: 塔头平臂吊2: 平头平臂吊
                    weightSet: '1', // C1是配置载重功能0:未配置1:已配置
                    windSpeedSet: '1', // C1是配置风速功能0:未配置1:已配置
                    rangeSet: '1', // C1是配置幅度功能0:未配置1:已配置
                    heightSet: '1', // C1是配置高度功能0:未配置1:已配置
                    angleSet: '1', // C1是配置角度功能0:未配置1:已配置
                    obliguitySet: '1', // C1是配置倾角功能0:未配置1:已配置
                    gpsSet: '1', // C1是配置gps功能0:未配置1:已配置
                    idSet: '1', // C1是配置人员识别功能0:未配置1:已配置
                    frontArmLength: '', // N5.2是臂长0.00~99.99m
                    backArmLength: '', // N5.2是尾臂长0.00~99.99m
                    maxWeight: '', // N5.2是最大吊重0.00~99.99t
                    ratedWindSpeed: '', // N5.2是额定风速0.00~36.90m/s
                    ratedWindLevel: '', // N2是额定风级0~12级
                    minRange: '', // N5.2是最小变幅0.00~99.99m
                    maxRange: '', // N5.2是最大变幅0.00~99.99m
                    armHeight: '', // N6.2是大臂高0.00~655.35m
                    maxHeight: '', // N6.2是最大高度0.00~655.35m
                    maxAngle: '', // N6.1是最大角度540.0°
                    minAngle: '', // N6.1是最小角度-540.0°
                    ratedObliguity: '', // N4.2是额定倾角0.00~9.99°
                    tc_MS_LoadCapacity: '', // N5.2是最大幅度允许最大载重0.00~99.99t
                    tc_ML_MaxScope: '', // N6.2是最大载重达到最大幅度0.00~655.3m
                    differInput: '', // N1是载重滤波等级1~9
                    settingMinHeight: '', // N6.1是高度报警阈值0.00~655.3m
                    weightZero: '', // N5.2是载重零点值0.00~99.99t
                    windSpeedZero: '', // N5.2是风速零点值0.00~99.99m/s
                    angleZero: '', // N5.1是角度零点值0.0~359.9°
                    dipXZero: '', // N4.2是倾角X零点值0.00~9.99°
                    dipYZero: '', // N4.2是倾角Y零点值0.00~9.99°
                    elevationAngleZero: '', // N5.2是动臂吊仰角零点值0.00~99.99°
                    multiFunExist: '1', // C1是配置多机防撞功能0:未配置1:已配置
                    latitude: '106.544691', // 纬度
                    longitude: '29.401571' // 经度
                }], // 塔吊监测基础信息
                craneConfig: {
                    name: '塔吊监测基础信息',
                    url: 'craneBasic',
                    config: {
                        deviceSN: {
                            type: 0,
                            name: '设备序列号',
                            parameter: '请输入设备序列号'
                        }, // 设备序列号
                        deviceID: {
                            type: 0,
                            name: '设备ID',
                            parameter: '请输入设备ID'
                        }, // 设备ID
                        craneType: {
                            type: 2,
                            name: '塔机类型',
                            parameter: {
                                0: '动臂吊',
                                1: '塔头平臂吊',
                                2: '平头平臂吊'
                            }
                        }, // 塔机类型0: 动臂吊1: 塔头平臂吊2: 平头平臂吊
                        weightSet: {
                            type: 1,
                            name: '配置载重功能',
                            parameter: baseRadio
                        }, // 配置载重功能0:未配置1:已配置
                        windSpeedSet: {
                            type: 1,
                            name: '配置风速功能',
                            parameter: baseRadio
                        }, // 配置风速功能0:未配置1:已配置
                        rangeSet: {
                            type: 1,
                            name: '配置幅度功能',
                            parameter: baseRadio
                        }, // 配置幅度功能0:未配置1:已配置
                        heightSet: {
                            type: 1,
                            name: '配置高度功能',
                            parameter: baseRadio
                        }, // 配置高度功能0:未配置1:已配置
                        angleSet: {
                            type: 1,
                            name: '配置角度功能',
                            parameter: baseRadio
                        }, // 配置角度功能0:未配置1:已配置
                        obliguitySet: {
                            type: 1,
                            name: '配置倾角功能',
                            parameter: baseRadio
                        }, // 配置倾角功能0:未配置1:已配置
                        gpsSet: {
                            type: 1,
                            name: '配置gps功能',
                            parameter: baseRadio
                        }, // 配置gps功能0:未配置1:已配置
                        idSet: {
                            type: 1,
                            name: '配置人员识别功能',
                            parameter: baseRadio
                        }, // 配置人员识别功能0:未配置1:已配置
                        frontArmLength: {
                            type: 0,
                            name: '臂长',
                            parameter: '限制区间 0.00~99.99m'
                        }, // 臂长0.00~99.99m
                        backArmLength: {
                            type: 0,
                            name: '尾臂长',
                            parameter: '限制区间 0.00~99.99m'
                        }, // 尾臂长0.00~99.99m
                        maxWeight: {
                            type: 0,
                            name: '最大吊重',
                            parameter: '限制区间 0.00~99.99t'
                        }, // 最大吊重0.00~99.99t
                        ratedWindSpeed: {
                            type: 0,
                            name: '额定风速',
                            parameter: '限制区间 0.00~36.90m/s'
                        }, // 额定风速0.00~36.90m/s
                        ratedWindLevel: {
                            type: 0,
                            name: '额定风级',
                            parameter: '限制区间 0~12级'
                        }, // 额定风级0~12级
                        minRange: {
                            type: 0,
                            name: '最小变幅',
                            parameter: '限制区间 0.00~99.99m'
                        }, // 最小变幅0.00~99.99m
                        maxRange: {
                            type: 0,
                            name: '最大变幅',
                            parameter: '限制区间 0.00~99.99m'
                        }, // 最大变幅0.00~99.99m
                        armHeight: {
                            type: 0,
                            name: '大臂高',
                            parameter: '限制区间 0.00~655.35m'
                        }, // 大臂高0.00~655.35m
                        maxHeight: {
                            type: 0,
                            name: '最大高度',
                            parameter: '限制区间 0.00~655.35m'
                        }, // 最大高度0.00~655.35m
                        maxAngle: {
                            type: 0,
                            name: '最大角度',
                            parameter: '限制区间 540.0°'
                        }, // 最大角度540.0°
                        minAngle: {
                            type: 0,
                            name: '最小角度',
                            parameter: '限制区间 -540.0°'
                        }, // 最小角度-540.0°
                        ratedObliguity: {
                            type: 0,
                            name: '额定倾角',
                            parameter: '限制区间 0.00~9.99°'
                        }, // 额定倾角0.00~9.99°
                        tc_MS_LoadCapacity: {
                            type: 0,
                            name: '最大幅度允许最大载重',
                            parameter: '限制区间 0.00~99.99t'
                        }, // 最大幅度允许最大载重0.00~99.99t
                        tc_ML_MaxScope: {
                            type: 0,
                            name: '最大载重达到最大幅度',
                            parameter: '限制区间 0.00~655.3m'
                        }, // 最大载重达到最大幅度0.00~655.3m
                        differInput: {
                            type: 0,
                            name: '载重滤波等级',
                            parameter: '限制区间 1~9'
                        }, // 载重滤波等级1~9
                        settingMinHeight: {
                            type: 0,
                            name: '高度报警阈值',
                            parameter: '限制区间 0.00~655.3m'
                        }, // 高度报警阈值0.00~655.3m
                        weightZero: {
                            type: 0,
                            name: '载重零点值',
                            parameter: '限制区间 0.00~99.99t'
                        }, // 载重零点值0.00~99.99t
                        windSpeedZero: {
                            type: 0,
                            name: '风速零点值',
                            parameter: '限制区间 0.00~99.99m/s'
                        }, // 风速零点值0.00~99.99m/s
                        angleZero: {
                            type: 0,
                            name: '角度零点值',
                            parameter: '限制区间 0.0~359.9°'
                        }, // 角度零点值0.0~359.9°
                        dipXZero: {
                            type: 0,
                            name: '倾角X零点值',
                            parameter: '限制区间 0.00~9.99°'
                        }, // 倾角X零点值0.00~9.99°
                        dipYZero: {
                            type: 0,
                            name: '倾角Y零点值',
                            parameter: '限制区间 0.00~9.99°'
                        }, // 倾角Y零点值0.00~9.99°
                        elevationAngleZero: {
                            type: 0,
                            name: '动臂吊仰角零点值',
                            parameter: '限制区间 0.00~99.99°'
                        }, // 动臂吊仰角零点值0.00~99.99°

                        latitude: {
                            type: 0,
                            name: '纬度',
                            parameter: '请输入纬度'
                        }, // 纬度
                        longitude: {
                            type: 0,
                            name: '经度',
                            parameter: '请输入经度'
                        }, // 经度

                        multiFunExist: {
                            type: 1,
                            name: '配置多机防撞功能',
                            parameter: baseRadio
                        }, // 配置多机防撞功能0:未配置1:已配置
                    } // type 0输入框 1单选 2下拉
                },

                elevator: [{
                    deviceSN: '', // C50是设备序列号
                    deviceID: '', // C50是设备ID
                    craneType: '1', // C1是升降机类型1: 单笼2: 双笼
                    idExist: '1', // C1是配置工号识别功能0:未配置1:已配置
                    peopleExist: '1', // C1是配置人数检测功能0:未配置1:已配置
                    weightExist: '1', // C1是配置载重功能0:未配置1:已配置
                    speedExist: '1', // C1是配置速度检测功能0:未配置1:已配置
                    heightExist: '1', // C1是配置高度检测功能0:未配置1:已配置
                    floorExist: '1', // C1是配置楼层功能0:未配置1:已配置
                    obliguityXExist: '1', // C1是配置X轴倾角功能0:未配置1:已配置
                    obliguityYExist: '1', // C1是配置Y轴倾角功能0:未配置1:已配置
                    windExist: '1', // C1是配置风速功能0:未配置1:已配置
                    gpsExist: '1', // C1是配置gps定位功能0:未配置1:已配置
                    wirelessExist: '1', // C1是配置无线功能0:未配置1:已配置
                    topExist: '1', // C1是配置上下限位(冲顶)检测功能0:未配置1:已配置
                    antiDropExist: '1', // C1是配置防坠器在位检测功能0:未配置1:已配置
                    outDoorStatus: '0', // C1是外笼门状态0:打开1:关闭
                    ratedPeople: '', // N2是额定运载人数1-20人
                    ratedWeight: '', // N4.2是额定载重0.00~9.99t
                    ratedUpSpeed: '', // N4.2是额定上行速度0.00~9.99m/s
                    ratedDownSpeed: '', // N4.2是额定下行速度0.00~9.99m/s
                    ratedHeight: '', // N5.1是额定高度0.0~999.9m
                    maxFloor: '', // N3是最大楼层0~100层
                    minFloor: '', // N2是最小楼层0~ -3层
                    ratedObliguityX: '', // N4.2是额定X轴倾角0.00~9.99°
                    ratedObliguityY: '', // N4.2是额定Y轴倾角0.00~9.99°
                    ratedWindSpeed: '', // N5.2是额定风速0.00~36.90m/s
                    ratedWindLevel: '', // N2是额定风级0~12级
                    latitude: '106.544691', // 纬度
                    longitude: '29.401571' // 经度
                }], // 升降机监测基础信息
                elevatorConfig: {
                    name: '升降机监测基础信息',
                    url: 'elevatorBasic',
                    config: {
                        deviceSN: {
                            type: 0,
                            name: '设备序列号',
                            parameter: '请输入设备序列号'
                        }, // C50是设备序列号
                        deviceID: {
                            type: 0,
                            name: '设备ID',
                            parameter: '请输入设备ID'
                        }, // C50是设备ID
                        craneType: {
                            type: 1,
                            name: '升降机类型',
                            parameter: {
                                1: '单笼',
                                2: '双笼'
                            }
                        }, // C1是升降机类型1: 单笼2: 双笼
                        idExist: {
                            type: 1,
                            name: '配置工号识别功能',
                            parameter: baseRadio
                        }, // C1是配置工号识别功能0:未配置1:已配置
                        peopleExist: {
                            type: 1,
                            name: '配置人数检测功能',
                            parameter: baseRadio
                        }, // C1是配置人数检测功能0:未配置1:已配置
                        weightExist: {
                            type: 1,
                            name: '配置载重功能',
                            parameter: baseRadio
                        }, // C1是配置载重功能0:未配置1:已配置
                        speedExist: {
                            type: 1,
                            name: '配置速度检测功能',
                            parameter: baseRadio
                        }, // C1是配置速度检测功能0:未配置1:已配置
                        heightExist: {
                            type: 1,
                            name: '配置高度检测功能',
                            parameter: baseRadio
                        }, // C1是配置高度检测功能0:未配置1:已配置
                        floorExist: {
                            type: 1,
                            name: '配置楼层功能',
                            parameter: baseRadio
                        }, // C1是配置楼层功能0:未配置1:已配置
                        obliguityXExist: {
                            type: 1,
                            name: '配置X轴倾角功能',
                            parameter: baseRadio
                        }, // C1是配置X轴倾角功能0:未配置1:已配置
                        obliguityYExist: {
                            type: 1,
                            name: '配置Y轴倾角功能',
                            parameter: baseRadio
                        }, // C1是配置Y轴倾角功能0:未配置1:已配置
                        windExist: {
                            type: 1,
                            name: '配置风速功能',
                            parameter: baseRadio
                        }, // C1是配置风速功能0:未配置1:已配置
                        gpsExist: {
                            type: 1,
                            name: '配置gps定位功能',
                            parameter: baseRadio
                        }, // C1是配置gps定位功能0:未配置1:已配置
                        wirelessExist: {
                            type: 1,
                            name: '配置无线功能',
                            parameter: baseRadio
                        }, // C1是配置无线功能0:未配置1:已配置
                        topExist: {
                            type: 1,
                            name: '配置上下限位(冲顶)检测功能',
                            parameter: baseRadio
                        }, // C1是配置上下限位(冲顶)检测功能0:未配置1:已配置
                        antiDropExist: {
                            type: 1,
                            name: '配置防坠器在位检测功能',
                            parameter: baseRadio
                        }, // C1是配置防坠器在位检测功能0:未配置1:已配置
                        outDoorStatus: {
                            type: 1,
                            name: '外笼门状态',
                            parameter: {
                                0: '打开',
                                1: '关闭'
                            }
                        }, // C1是外笼门状态0:打开1:关闭
                        ratedPeople: {
                            type: 0,
                            name: '额定运载人数',
                            parameter: '限制区间 1-20人'
                        }, // N2是额定运载人数1-20人
                        ratedWeight: {
                            type: 0,
                            name: '额定载重',
                            parameter: '限制区间 0.00~9.99t'
                        }, // N4.2是额定载重0.00~9.99t
                        ratedUpSpeed: {
                            type: 0,
                            name: '额定上行速度',
                            parameter: '限制区间 0.00~9.99m/s'
                        }, // N4.2是额定上行速度0.00~9.99m/s
                        ratedDownSpeed: {
                            type: 0,
                            name: '额定下行速度',
                            parameter: '限制区间 0.00~9.99m/s'
                        }, // N4.2是额定下行速度0.00~9.99m/s
                        ratedHeight: {
                            type: 0,
                            name: '额定高度',
                            parameter: '限制区间 0.0~999.9m'
                        }, // N5.1是额定高度0.0~999.9m
                        maxFloor: {
                            type: 0,
                            name: '最大楼层',
                            parameter: '限制区间 0~100层'
                        }, // N3是最大楼层0~100层
                        minFloor: {
                            type: 0,
                            name: '最小楼层',
                            parameter: '限制区间 0~ -3层'
                        }, // N2是最小楼层0~ -3层
                        ratedObliguityX: {
                            type: 0,
                            name: '额定X轴倾角',
                            parameter: '限制区间 0.00~9.99°'
                        }, // N4.2是额定X轴倾角0.00~9.99°
                        ratedObliguityY: {
                            type: 0,
                            name: '额定Y轴倾角',
                            parameter: '限制区间 0.00~9.99°'
                        }, // N4.2是额定Y轴倾角0.00~9.99°
                        ratedWindSpeed: {
                            type: 0,
                            name: '额定风速',
                            parameter: '限制区间 0.00~36.90m/s'
                        }, // N5.2是额定风速0.00~36.90m/s
                        ratedWindLevel: {
                            type: 0,
                            name: '额定风级',
                            parameter: '限制区间 0~12级'
                        }, // N2是额定风级0~12级
                        latitude: {
                            type: 0,
                            name: '纬度',
                            parameter: '请输入纬度'
                        }, // 纬度
                        longitude: {
                            type: 0,
                            name: '经度',
                            parameter: '请输入经度'
                        }, // 经度
                    }
                },

                unloading: [{
                    deviceSN: '', // 设备序列号
                    deviceID: '', // 设备ID
                    state: '0', // 卸料平台类型0是正常，1为超重 (若不传相关参数，则系统会默认为0)
                    load: '', // 载重预警阈值
                    loadWarn: '', // 载重报警阈值
                    dipXWarn: '', // 倾角X预警阈值
                    dipYWarn: '', // 倾角Y预警阈值
                    dipXAlarm: '', // 倾角X报警阈值
                    dipYAlarm: '', // 倾角Y报警阈值

                }], // 卸料平台监测基础信息
                unloadingConfig: {
                    name: '卸料平台监测基础信息',
                    url: 'unloadingBasic',
                    config: {
                        deviceSN: {
                            type: 0,
                            name: '设备序列号',
                            parameter: '请输入设备序列号'
                        }, // 设备序列号
                        deviceID: {
                            type: 0,
                            name: '设备ID',
                            parameter: '请输入设备ID'
                        }, // 设备ID
                        state: {
                            type: 1,
                            name: '设备供应商',
                            parameter: {
                                0: '正常',
                                1: '超重'
                            }
                        }, // 卸料平台类型0是正常，1为超重(若不传相关参数，则系统会默认为0)
                        load: {
                            type: 0,
                            name: '载重预警阈值',
                            parameter: '请输入载重预警阈值'
                        }, // 载重预警阈值
                        loadWarn: {
                            type: 0,
                            name: '载重报警阈值',
                            parameter: '请输入载重报警阈值'
                        }, // 载重报警阈值
                        dipXWarn: {
                            type: 0,
                            name: '倾角X预警阈值',
                            parameter: '请输入倾角X预警阈值'
                        }, // 倾角X预警阈值
                        dipYWarn: {
                            type: 0,
                            name: '倾角Y预警阈值',
                            parameter: '请输入倾角Y预警阈值'
                        }, // 倾角Y预警阈值
                        dipXAlarm: {
                            type: 0,
                            name: '倾角X报警阈值',
                            parameter: '请输入倾角X报警阈值'
                        }, // 倾角X报警阈值
                        dipYAlarm: {
                            type: 0,
                            name: '倾角Y报警阈值',
                            parameter: '请输入倾角Y报警阈值'
                        }, // 倾角Y报警阈值

                    }
                },

                helmet: [{
                    deviceSN: '', // 设备序列号
                    deviceID: '', // 设备 ID
                }], // AI监测基础数据
                helmetConfig: {
                    name: 'AI监测基础数据',
                    url: '',
                    config: {
                        deviceSN: {
                            type: 0,
                            name: '设备序列号',
                            parameter: '请输入设备序列号'
                        },
                        deviceID: {
                            type: 0,
                            name: '设备 ID',
                            parameter: '请输入建委设备ID'
                        },
                    } // type 0输入框 1单选 2下拉
                },

                pushGPSLocationInfo: [{
                    deviceSN: '', // 设备序列号
                    deviceID: '', // 设备ID
                    workerName: '', // 佩戴人员姓名
                    idCardType: '01', // 证件类型
                    idCardNumber: '', // 证件号码
                    lng: '29.401571', // 经度
                    lat: '106.544691', // 纬度
                    height: '', // 高度
                }], // 人员安全帽GPS定位信息
                pushGPSLocationInfoConfig: {
                    name: '人员安全帽GPS定位信息',
                    url: 'pushGPSLocationInfo',
                    config: {
                        deviceSN: {
                            type: 0,
                            name: '设备序列号',
                            parameter: '请输入设备序列号',
                            isNotMust: true
                        },
                        deviceID: {
                            type: 0,
                            name: '设备ID',
                            parameter: '请输入设备ID',
                            isNotMust: true
                        },
                        workerName: {
                            type: 0,
                            name: '佩戴人员姓名',
                            parameter: '请输入佩戴人员姓名',
                            isNotMust: true
                        },
                        idCardNumber: {
                            type: 0,
                            name: '证件号码',
                            parameter: '请输入证件号码',
                            isNotMust: true
                        },
                        lng: {
                            type: 0,
                            name: '经度',
                            parameter: '请输入经度',
                            isNotMust: true
                        },
                        lat: {
                            type: 0,
                            name: '纬度',
                            parameter: '请输入纬度',
                            isNotMust: true
                        },
                        height: {
                            type: 0,
                            name: '高度',
                            parameter: '请输入高度'
                        },
                    } // type 0输入框 1单选 2下拉
                },

                pushLocationMap: [{
                    mapId: '', // 定位底图Id
                    areaWidth: '', // 底图区域实际宽度
                    areaHeight: '', // 底图区域实际高度
                    mapPic: '', // 底图图片url
                }], // 人员定位底图信息
                pushLocationMapConfig: {
                    name: '人员定位底图信息',
                    url: 'pushLocationMap',
                    config: {
                        mapId: {
                            type: 0,
                            name: '定位底图Id',
                            parameter: '请输入定位底图Id',
                            isNotMust: true
                        },
                        areaWidth: {
                            type: 0,
                            name: '底图区域实际宽度',
                            parameter: '单位：m',
                            isNotMust: true
                        },
                        areaHeight: {
                            type: 0,
                            name: '底图区域实际高度',
                            parameter: '单位：m',
                            isNotMust: true
                        },
                        mapPic: {
                            type: 0,
                            name: '底图图片url',
                            parameter: '小于500KB，像素>1024*768',
                            isNotMust: true
                        },
                    } // type 0输入框 1单选 2下拉
                },

                pushXYZLocation: [{
                    deviceSN: '', // 设备序列号
                    deviceID: '', // 设备ID
                    mapId: '', // 定位底图Id
                    workerName: '', // 人员姓名
                    idCardType: '01', // 人员证件类型
                    idCardNumber: '', // 人员证件号码
                    locationX: '', // x轴位置
                    locationY: '', // y轴位置
                    locationZ: '', // z轴位置
                    locationName: '', // 所在位置名称
                }], // 人员定位信息
                pushXYZLocationConfig: {
                    name: '人员定位信息',
                    url: 'pushXYZLocation',
                    config: {
                        deviceSN: {
                            type: 0,
                            name: '设备序列号',
                            parameter: '请输入设备序列号'
                        },
                        deviceID: {
                            type: 0,
                            name: '设备ID',
                            parameter: '请输入设备ID',
                            isNotMust: true
                        },
                        mapId: {
                            type: 0,
                            name: '定位底图Id',
                            parameter: '请输入定位底图Id',
                            isNotMust: true
                        },
                        workerName: {
                            type: 0,
                            name: '人员姓名',
                            parameter: '请输入人员姓名',
                            isNotMust: true
                        },
                        idCardNumber: {
                            type: 0,
                            name: '人员证件号码',
                            parameter: '请输入人员证件号码',
                            isNotMust: true
                        },
                        locationX: {
                            type: 0,
                            name: 'x轴位置',
                            parameter: '单位cm，原点为底图左下角，位置为相对于实际原点距离',
                            isNotMust: true
                        },
                        locationY: {
                            type: 0,
                            name: 'y轴位置',
                            parameter: '单位cm，原点为底图左下角，位置为相对于实际原点距离',
                            isNotMust: true
                        },
                        locationZ: {
                            type: 0,
                            name: 'z轴位置',
                            parameter: '单位cm，相对地面高度'
                        },
                        locationName: {
                            type: 0,
                            name: '所在位置名称',
                            parameter: '如楼层编号'
                        },
                    } // type 0输入框 1单选 2下拉
                },

                pushVehiclewashinfo: [{
                    deviceSN: '', // 设备序列号
                    deviceID: '', // 设备ID
                    captureTime: '', // 抓拍时间
                    carNo: '', // 车牌号
                    carColor: '1', // 车牌颜色
                    vehicleEntryTime: '', // 车辆进入时间
                    vehicleDepartureTime: '', // 车辆离开时间
                    snapPhotos: '', // 抓拍照片文件地址
                    snapVideoUrl: '', // 抓拍视频文件地址
                    vehicleType: '2', // 车型
                    warnType: '5', // 告警类型
                    entranceorExit: '1', // 进出场标记
                }], // 车辆未冲洗检测抓拍信息
                pushVehiclewashinfoConfig: {
                    name: '车辆未冲洗检测抓拍信息',
                    url: 'pushVehiclewashinfo',
                    config: {
                        deviceSN: {
                            type: 0,
                            name: '设备序列号',
                            parameter: '请输入设备序列号',
                            isNotMust: true
                        },
                        deviceID: {
                            type: 0,
                            name: '设备ID',
                            parameter: '请输入设备ID',
                            isNotMust: true
                        },
                        captureTime: {
                            type: 3,
                            name: '抓拍时间',
                            parameter: '',
                            isNotMust: true
                        },
                        carNo: {
                            type: 0,
                            name: '车牌号',
                            parameter: '请输入车牌号',
                            isNotMust: true
                        },
                        carColor: {
                            type: 1,
                            name: '车牌颜色',
                            parameter: {
                                '1': '黄',
                                '2': '蓝'
                            },
                            isNotMust: true
                        },
                        vehicleEntryTime: {
                            type: 3,
                            name: '车辆进入时间',
                            parameter: '',
                            isNotMust: true
                        },
                        vehicleDepartureTime: {
                            type: 3,
                            name: '车辆离开时间',
                            parameter: '',
                            isNotMust: true
                        },
                        snapPhotos: {
                            type: 0,
                            name: '抓拍照片文件地址',
                            parameter: '不超过500KB',
                            isNotMust: true
                        },
                        snapVideoUrl: {
                            type: 0,
                            name: '抓拍视频文件地址',
                            parameter: '如（http://XXX/video.mp4）',
                            isNotMust: true
                        },
                        vehicleType: {
                            type: 1,
                            name: '车型',
                            parameter: {
                                '1': '小型车',
                                '2': '大型车'
                            },
                            isNotMust: true
                        },
                        warnType: {
                            type: 2,
                            name: '告警类型',
                            parameter: '请输入告警类型(1：车辆绕行  2：冲洗时间不足  3：未冲洗 4：其他 5:正常冲洗)',
                            parameter: {
                                '1': '车辆绕行',
                                '2': '冲洗时间不足',
                                '3': '未冲洗',
                                '4': '其他',
                                '5': '正常冲洗'
                            },
                            isNotMust: true
                        },
                        entranceorExit: {
                            type: 1,
                            name: '进出场标记',
                            parameter: '请输入进出场标记（0:进场 1：出场）',
                            parameter: {
                                '0': '进场',
                                '1': '出场'
                            },
                            isNotMust: true
                        },

                    } // type 0输入框 1单选 2下拉
                },

                pushRiskLevel: [{
                    fxLevel: '', // 风险等级
                    fxPlace: '', // 风险部位
                    description: '', // 风险描述
                    prjDType: '', // 危大工程类型
                    accidentType: '', // 可能导致事故类型
                    riskAdvice: '', // 主要管控措施
                    createTime: '', // 风险登记时间
                    isClosed: '', // 风险是否关闭
                    closedTime: '', // 风险关闭时间
                    zrdwCorpCode: '', // 责任单位统一社会信用代码
                    zrdwCorpName: '', // 责任单位名称
                    zrrName: '', // 责任人姓名
                    zrrIDCardType: '01', // 责任人证件类型
                    zrrCardNumber: '', // 责任人证件号码
                }], // 风险分级信息
                pushRiskLevelConfig: {
                    name: '风险分级信息',
                    url: 'pushRiskLevel',
                    config: {
                        fxLevel: {
                            type: 2,
                            name: '风险等级',
                            parameter: {
                                '01': '低度风险',
                                '02': '中度风险',
                                '03': '高度风险',
                                '04': '极高风险',
                            },
                            isNotMust: true
                        },
                        fxPlace: {
                            type: 0,
                            name: '风险部位',
                            parameter: '请输入风险部位',
                            isNotMust: true
                        },
                        description: {
                            type: 0,
                            name: '风险描述',
                            parameter: '请输入风险描述',
                            isNotMust: true
                        },
                        prjDType: {
                            type: 1,
                            name: '危大工程类型',
                            parameter: {
                                '01': '一般规模',
                                '02': '超过一定规模',
                            }
                        },
                        accidentType: {
                            type: 2,
                            name: '可能导致事故类型',
                            parameter: {
                                '01': '高处坠落',
                                '02': '物体打击',
                                '03': '起重伤害',
                                '04': '坍塌',
                                '05': '触电',
                                '06': '机械伤害',
                                '07': '车辆伤害',
                                '08': '中毒和窒息',
                                '09': '火灾和爆炸',
                                '99': '其他',
                            },
                            isNotMust: true
                        },
                        riskAdvice: {
                            type: 0,
                            name: '主要管控措施',
                            parameter: '请输入主要管控措施',
                            isNotMust: true
                        },
                        createTime: {
                            type: 3,
                            name: '风险登记时间',
                            parameter: '',
                            isNotMust: true
                        },
                        isClosed: {
                            type: 1,
                            name: '风险是否关闭',
                            parameter: {
                                0: '否',
                                1: '是'
                            },
                            isNotMust: true
                        },
                        closedTime: {
                            type: 3,
                            name: '风险关闭时间',
                            parameter: ''
                        },
                        zrdwCorpCode: {
                            type: 0,
                            name: '责任单位统一社会信用代码',
                            parameter: '请输入责任单位统一社会信用代码',
                            isNotMust: true
                        },
                        zrdwCorpName: {
                            type: 0,
                            name: '责任单位名称',
                            parameter: '请输入责任单位名称',
                            isNotMust: true
                        },
                        zrrName: {
                            type: 0,
                            name: '责任人姓名',
                            parameter: '请输入责任人姓名',
                            isNotMust: true
                        },
                        zrrCardNumber: {
                            type: 0,
                            name: '责任人证件号码',
                            parameter: '请输入责任人证件号码',
                            isNotMust: true
                        },

                    } // type 0输入框 1单选 2下拉 3时间
                },

                pushSafetySelfCheck: [{
                    checkListNo: '', //检查单编号
                    checkLevel: '', //检查级别
                    checkType: '', //检查类型
                    checkPosition: '', //检查部位
                    checkTime: '', //检查时间
                    superVisorName: '', //安管人员姓名
                    superVisorIDCardType: '01', //安管人员证件类型
                    superVisorIDNumber: '', //安管人员证件证号
                    createTime: '', //检查登记时间，格式：yyyy-MM-dd HH:mm:ss
                    checkConclude: '', //检查结论
                    riskTroubleResult: '', //风险失控表现
                    hTName: '', //隐患名称
                    hTNum: '', //隐患编号，判断唯一
                    hTLevel: '', //隐患级别，详见隐患级别代码项
                    whetherCheckEnd: '', //是否整改完成，是否字典表
                    checkAttachs: '', //问题照片附件。JSON 数组，附件总数不超过 5 个
                    rectification: '', //整改措施
                    zgdwCorpCode: '', //整改单位统一社会信用代码
                    zgfzrName: '', //整改负责人姓名
                    zgfzrIDCardType: '01', //整改负责人证件类型，详见人员证件类型字典表
                    zgfzrCardNumber: '', //整改负责人证件证号
                    zgtzdAttach: '', //整改通知单附件，不超过 500KB 的 BASE64 字符串
                    rectificationend: '', //整改完成情况
                    zgwcAttachs: '', //整改完成照片附件。JSON 数组，附件总数不超过 5 个
                    sjwcDate: '', //实际整改完成日期，格式：yyyy-MM-dd，whetherCheckEnd=1时必填
                }], // 安全自检信息
                pushSafetySelfCheckConfig: {
                    name: '安全自检信息',
                    url: 'pushSafetySelfCheck',
                    config: {
                        checkListNo: {
                            type: 0,
                            name: '检查单编号',
                            parameter: '请输入检查单编号',
                            isNotMust: true
                        },
                        checkLevel: {
                            type: 1,
                            name: '检查级别',
                            parameter: {
                                '01': '项目自查',
                                '02': '企业检查'
                            },
                            isNotMust: true
                        },
                        checkType: {
                            type: 2,
                            name: '检查类型',
                            parameter: {
                                '01': '日检',
                                '02': '周检',
                                '03': '月检',
                            },
                            isNotMust: true
                        },
                        checkPosition: {
                            type: 0,
                            name: '检查部位',
                            parameter: '请输入检查部位',
                            isNotMust: true
                        },
                        checkTime: {
                            type: 3,
                            name: '检查时间',
                            parameter: '',
                            isNotMust: true
                        },
                        superVisorName: {
                            type: 0,
                            name: '安管人员姓名',
                            parameter: '请输入安管人员姓名',
                            isNotMust: true
                        },
                        superVisorIDNumber: {
                            type: 0,
                            name: '安管人员证件证号',
                            parameter: '请输入安管人员证件证号',
                            isNotMust: true
                        },
                        createTime: {
                            type: 3,
                            name: '检查登记时间',
                            parameter: '',
                            isNotMust: true
                        },
                        checkConclude: {
                            type: 0,
                            name: '检查结论',
                            parameter: '请输入检查结论',
                            isNotMust: true
                        },
                        riskTroubleResult: {
                            type: 0,
                            name: '风险失控表现',
                            parameter: '请输入风险失控表现'
                        },
                        hTName: {
                            type: 0,
                            name: '隐患名称',
                            parameter: '请输入隐患名称'
                        },
                        hTNum: {
                            type: 0,
                            name: '隐患编号',
                            parameter: '请输入隐患编号（判断唯一）'
                        },
                        hTLevel: {
                            type: 1,
                            name: '隐患级别',
                            parameter: {
                                '01': '一般隐患',
                                '02': '重大安全隐患'
                            }
                        },
                        whetherCheckEnd: {
                            type: 1,
                            name: '是否整改完成，是否字典表',
                            parameter: {
                                0: '否',
                                1: '是'
                            }
                        },
                        checkAttachs: {
                            type: 0,
                            name: '问题照片附件地址',
                            parameter: '不超过5个，以逗号隔开'
                        },
                        rectification: {
                            type: 0,
                            name: '整改措施',
                            parameter: '请输入整改措施'
                        },
                        zgdwCorpCode: {
                            type: 0,
                            name: '整改单位统一社会信用代码',
                            parameter: '请输入整改单位统一社会信用代码'
                        },
                        zgfzrName: {
                            type: 0,
                            name: '整改负责人姓名',
                            parameter: '请输入整改负责人姓名'
                        },
                        zgfzrCardNumber: {
                            type: 0,
                            name: '整改负责人证件证号',
                            parameter: '请输入整改负责人证件证号'
                        },
                        zgtzdAttach: {
                            type: 0,
                            name: '整改通知单附件地址',
                            parameter: '不超过500KB'
                        },
                        rectificationend: {
                            type: 0,
                            name: '整改完成情况',
                            parameter: '请输入整改完成情况'
                        },
                        zgwcAttachs: {
                            type: 0,
                            name: '整改完成照片附件地址',
                            parameter: '不超过5个，以逗号隔开'
                        },
                        sjwcDate: {
                            type: 3,
                            name: '实际整改完成日期',
                            parameter: ''
                        },

                    } // type 0输入框 1单选 2下拉 3时间
                },

                pushAcceptanceOfWorks: [{
                    areaCode: '', // 工程所属区划
                    proaccType: '', // 工程验收项目类型
                    acdateTime: '', // 隐检日期(验收日期)
                    actitem: '', // 隐检项目(分项工程)
                    acposition: '', // 隐检部位(验收部位)
                    inspectionreporturl: '', // 验收报告，下载地址
                    jsdwCorpCode: '', // 建设单位统一社会信用代码
                    jsdwName: '', // 建设单位名称
                    jldwCorpCode: '', // 监理单位统一信用代码
                    jldwName: '', // 监理单位名称
                    sgdwCorpCode: '', // 施工单位统一社会信用代码
                    sgdwName: '', // 施工单位名称
                    contractcorpPerson: '', // 施工单位联系人
                    contractcorpPersonPhone: '', // 施工单位联系人电话
                }], // 工程验收信息
                pushAcceptanceOfWorksConfig: {
                    name: '工程验收信息',
                    url: 'pushAcceptanceOfWorks',
                    config: {
                        areaCode: {
                            type: 0,
                            name: '工程所属区划',
                            parameter: '右上角查询后输入区划代码',
                            isNotMust: true
                        },
                        proaccType: {
                            type: 1,
                            name: '工程验收项目类型',
                            parameter: {
                                '1': '隐蔽工程',
                                '2': '分项工程'
                            },
                            isNotMust: true
                        },
                        acdateTime: {
                            type: 3,
                            name: '隐检日期(验收日期)',
                            parameter: '',
                            isNotMust: true
                        },
                        actitem: {
                            type: 0,
                            name: '隐检项目(分项工程)',
                            parameter: '请输入隐检项目(分项工程)',
                            isNotMust: true
                        },
                        acposition: {
                            type: 0,
                            name: '隐检部位(验收部位)',
                            parameter: '请输入隐检部位(验收部位)',
                            isNotMust: true
                        },
                        inspectionreporturl: {
                            type: 0,
                            name: '验收报告附件地址',
                            parameter: '请输入验收报告附件地址'
                        },
                        jsdwCorpCode: {
                            type: 0,
                            name: '建设单位统一社会信用代码',
                            parameter: '请输入建设单位统一社会信用代码',
                            isNotMust: true
                        },
                        jsdwName: {
                            type: 0,
                            name: '建设单位名称',
                            parameter: '请输入建设单位名称',
                            isNotMust: true
                        },
                        jldwCorpCode: {
                            type: 0,
                            name: '监理单位统一信用代码',
                            parameter: '请输入监理单位统一信用代码',
                            isNotMust: true
                        },
                        jldwName: {
                            type: 0,
                            name: '监理单位名称',
                            parameter: '请输入监理单位名称',
                            isNotMust: true
                        },
                        sgdwCorpCode: {
                            type: 0,
                            name: '施工单位统一社会信用代码',
                            parameter: '请输入施工单位统一社会信用代码',
                            isNotMust: true
                        },
                        sgdwName: {
                            type: 0,
                            name: '施工单位名称',
                            parameter: '请输入施工单位名称',
                            isNotMust: true
                        },
                        contractcorpPerson: {
                            type: 0,
                            name: '施工单位联系人',
                            parameter: '请输入施工单位联系人',
                            isNotMust: true
                        },
                        contractcorpPersonPhone: {
                            type: 0,
                            name: '施工单位联系人电话',
                            parameter: '请输入施工单位联系人电话',
                            isNotMust: true
                        },

                    } // type 0输入框 1单选 2下拉 3时间
                },

                uploadList: {}, // 上传列表
                showUpload: false, // 上传列表弹窗开关
                uploading: 0, // 正在上传数量
                upload_successful: 0, // 上传成功数量
                upload_failure: 0 // 上传失败数量
            };
        },
        created() {
            this.fnGetExtendInfo();
        },
        methods: {
            // 获取重庆市建委3.0项目扩展信息
            fnGetExtendInfo() {
                request({
                        url: 'project/getAllRegionExtend?region=cq2',
                        method: 'GET'
                    })
                    .then(res => {
                        if (res.data.length < 0) return;

                        let data = res.data[0];
                        this.editId = data.id;
                        this.access = data.access ? JSON.parse(data.access) : this.access;
                        this.monitor = data.monitor ? JSON.parse(data.monitor) : this.monitor;
                        this.env = data.env ? JSON.parse(data.env) : this.env;
                        this.crane = data.crane ? JSON.parse(data.crane) : this.crane;
                        this.elevator = data.elevator ? JSON.parse(data.elevator) : this.elevator;
                        this.unloading = data.unloading ? JSON.parse(data.unloading) : this.unloading;
                        this.helmet = data.helmet ? JSON.parse(data.helmet) : this.helmet;
                        this.pushGPSLocationInfo = data.pushGPSLocationInfo ? JSON.parse(data.pushGPSLocationInfo) :
                            this.pushGPSLocationInfo;
                        this.pushLocationMap = data.pushLocationMap ? JSON.parse(data.pushLocationMap) : this
                            .pushLocationMap;
                        this.pushXYZLocation = data.pushXYZLocation ? JSON.parse(data.pushXYZLocation) : this
                            .pushXYZLocation;
                        this.pushTVOCRealTimeInfo = data.pushTVOCRealTimeInfo ? JSON.parse(data
                            .pushTVOCRealTimeInfo) : this.pushTVOCRealTimeInfo;
                        this.pushEnSewageDischargeDetect = data.pushEnSewageDischargeDetect ? JSON.parse(data
                            .pushEnSewageDischargeDetect) : this.pushEnSewageDischargeDetect;
                        this.pushVehiclewashinfo = data.pushVehiclewashinfo ? JSON.parse(data.pushVehiclewashinfo) :
                            this.pushVehiclewashinfo;
                        this.pushRiskLevel = data.pushRiskLevel ? JSON.parse(data.pushRiskLevel) : this
                            .pushRiskLevel;
                        this.pushSafetySelfCheck = data.pushSafetySelfCheck ? JSON.parse(data.pushSafetySelfCheck) :
                            this.pushSafetySelfCheck;
                        this.pushAcceptanceOfWorks = data.pushAcceptanceOfWorks ? JSON.parse(data
                            .pushAcceptanceOfWorks) : this.pushAcceptanceOfWorks;

                    })
                    .catch(err => {
                        if (err.data) {
                            this.$message.error(err.data);
                        }
                    });
            },

            // 上传市建委
            fnUpload() {
                this.$confirm('请选择上传方式', '提示', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '上传当前选项',
                        cancelButtonText: '上传所有选项'
                    })
                    .then(() => {
                        this.fnEditExtendInfo(this.activeName);
                    })
                    .catch(action => {
                        if (action !== 'cancel') return;
                        this.fnEditExtendInfo();
                    });
            },

            // 保存至数据库
            fnEditExtendInfo(_type) {
                let _obj = {};
                if (_type) {
                    _obj[_type] = JSON.stringify(this[_type]);
                } else {
                    _obj.access = JSON.stringify(this.access);
                    _obj.monitor = JSON.stringify(this.monitor);
                    _obj.env = JSON.stringify(this.env);
                    _obj.crane = JSON.stringify(this.crane);
                    _obj.elevator = JSON.stringify(this.elevator);
                    _obj.unloading = JSON.stringify(this.unloading);
                    _obj.helmet = JSON.stringify(this.helmet);
                    _obj.pushGPSLocationInfo = JSON.stringify(this.pushGPSLocationInfo);
                    _obj.pushLocationMap = JSON.stringify(this.pushLocationMap);
                    _obj.pushXYZLocation = JSON.stringify(this.pushXYZLocation);
                    _obj.pushTVOCRealTimeInfo = JSON.stringify(this.pushTVOCRealTimeInfo);
                    _obj.pushEnSewageDischargeDetect = JSON.stringify(this.pushEnSewageDischargeDetect);
                    _obj.pushVehiclewashinfo = JSON.stringify(this.pushVehiclewashinfo);
                    _obj.pushRiskLevel = JSON.stringify(this.pushRiskLevel);
                    _obj.pushSafetySelfCheck = JSON.stringify(this.pushSafetySelfCheck);
                    _obj.pushAcceptanceOfWorks = JSON.stringify(this.pushAcceptanceOfWorks);
                }
                // 对参数个体进行验证
                for (let _key in _obj) {
                    for (let _data_key in this[_key]) {
                        for (let _platform_key in this[_key][_data_key]) {
                            if (!this[_key][_data_key][_platform_key] && !this[_key + 'Config'].config[_platform_key]
                                .hasOwnProperty('isNotMust')) {
                                this.$message.warning(this[_key + 'Config'].name + '-' + this[_key + 'Config'].config[
                                    _platform_key].name + ' ' + '参数不能为空');
                                return;
                            }
                        }
                    }
                }

                let upload_data = JSON.parse(JSON.stringify(_obj));
                upload_data.region = 'cq2';
                if (this.editId) upload_data.id = this.editId;

                request({
                        url: 'project/addAllRegionExtend',
                        method: 'POST',
                        data: upload_data
                    })
                    .then(res => {
                        this.fnGetExtendInfo();
                        this.$message.success(res.data);
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });

                this.fnUploadGov(_obj);
            },

            // 上传至市建委
            fnUploadGov(_obj) {

                this.showUpload = true;

                for (let _key in _obj) {
                    let config = this[_key + 'Config'];

                    for (let _data_key in this[_key]) {
                        this.uploading++;

                        let list_key = _key + _data_key;
                        this.uploadList[list_key] = {
                            name: config.name + ' 设备-' + (Number(_data_key) + 1),
                            result: 1, //1上传中，2上传成功，3上传失败
                            details: ''
                        };

                        if (!config.url) {
                            this.uploading--;
                            this.uploadList[list_key].result = 2;
                            this.upload_successful++;
                        } else {
                            fnRequestPlatform({
                                    url: '/Cq2/' + config.url,
                                    method: 'POST',
                                    data: {
                                        carry: this[_key][_data_key]
                                    }
                                },
                                res => {
                                    this.uploading--;
                                    if (res.code === 1) {
                                        this.uploadList[list_key].result = 2;
                                        this.upload_successful++;
                                    } else {
                                        this.uploadList[list_key].details = res.data;
                                        this.uploadList[list_key].result = 3;
                                        this.upload_failure++;
                                    }
                                }
                            );
                        }
                    }
                }
            },

            // 关闭上传列表弹窗
            fnUploadFinish() {
                this.showUpload = false;
                this.uploadList = {};
                this.uploading = 0;
                this.upload_successful = 0;
                this.upload_failure = 0;
            }
        }
    };
</script>
<style lang="scss" scoped>
    @import '~@/styles/mixin.scss';

    .led_box {
        width: 1920px;
        height: 858px;
        position: relative;
        overflow: hidden;

        .led {
            position: absolute;
            left: 0;
            right: -20px;
            top: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
        }
    }

    .content_box {
        position: relative;
        overflow: hidden;
        background-color: rgba(29, 68, 149, 0.1);
        width: 1880px;
        height: 848px;
        margin: 10px 0 0 20px;

        .content_title {
            width: 1880px;
            height: 50px;
            line-height: 50px;
            font-size: 26px;
            text-align: center;
        }

        .content {
            width: 1880px;
            height: 730px;
            position: relative;
            overflow: hidden;

            .content_tab {
                position: absolute;
                left: 0;
                right: -30px;
                top: 0;
                bottom: 0;
                overflow-x: hidden;
                overflow-y: auto;

                .location {
                    position: absolute;
                    top: 10px;
                    right: 80px;
                    color: #3a8ee6;
                }

                >>>.el-tabs--border-card {
                    width: 1880px;
                    height: 730px;
                    border: none;
                    background: transparent;
                }

                >>>.el-tabs--border-card>.el-tabs__header {
                    background: url(../../../assets/img/per_list_bg.png) no-repeat;
                    background-size: 100% 100%;
                    border: none;

                    .el-tabs__nav-wrap {
                        padding: 0 30px;

                        .el-tabs__nav-prev {
                            font-size: 20px;
                            width: 30px;
                            text-align: center;
                            line-height: 40px;
                        }

                        .el-tabs__nav-next {
                            font-size: 20px;
                            width: 30px;
                            text-align: center;
                            line-height: 40px;
                        }
                    }

                }

                >>>.el-tabs--border-card>.el-tabs__header .el-tabs__item {
                    border: none !important;
                }

                >>>.el-tabs__item {
                    color: rgba(255, 255, 255, 0.8);
                }

                >>>.el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover {
                    color: #409eff;
                }

                >>>.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
                    color: #409eff;
                    background-color: rgba(0, 255, 255, 0.1);
                    border: none !important;
                }

                >>>.el-input {
                    width: 220px;
                }

                >>>.el-input__inner {
                    width: 220px;
                    height: 30px;
                    border-radius: 2px;
                    border: none;
                    color: rgb(99, 195, 255);
                    background-color: rgba(49, 88, 128, 0.4);

                    &::-webkit-input-placeholder {
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &::-moz-placeholder {
                        /* Mozilla Firefox 19+ */
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &:-moz-placeholder {
                        /* Mozilla Firefox 4 to 18 */
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &:-ms-input-placeholder {
                        /* Internet Explorer 10-11 */
                        color: rgba(77, 180, 244, 0.7);
                    }
                }
            }
        }

        >>>.el-switch__core:after {
            content: '';
        }
    }

    .data_list {
        position: absolute;
        top: 0;
        left: 1620px;
        width: 300px;
        height: 848px;
        margin-top: 10px;
        background-color: rgba(29, 68, 149, 0.1);

        .title {
            width: 300px;
            height: 60px;
            font-size: 24px;
            background: url(../../../assets/img/per_list_bg.png) no-repeat;
            background-size: 100% 100%;
            @include flex-box(center, center);
        }

        .list_title {
            width: 300px;
            height: 48px;
            background: url(../../../assets/img/enter_left_bg.png) no-repeat;
            background-size: 100% 100%;
            @include flex-box(flex-start, center);

            .title_item {
                width: 96px;
                margin: 0 2px;
                text-align: center;

                &:nth-child(1) {
                    width: 196px;
                }
            }
        }

        .list_box {
            width: 300px;
            height: 740px;

            .box_line {
                width: 300px;
                height: 48px;
                cursor: pointer;
                border-bottom: 1px dashed #1d4495;
                @include flex-box(center, center);

                &:hover {
                    background-color: rgba(49, 88, 128, 0.4);
                }

                .line_item {
                    width: 96px;
                    margin: 0 2px;
                    text-align: center;

                    &:nth-child(1) {
                        width: 196px;
                    }
                }
            }
        }
    }

    .dialog_choose {
        .line_item {
            margin: 5px;
            height: 20px;
            line-height: 20px;
            color: rgba(255, 255, 255, 0.8);
        }

        .btn_line {
            @include flex-box(center, center);
        }

        >>>.el-dialog {
            background-color: rgba(9, 17, 32, 1);
            border: 1px solid rgba(58, 116, 221, 1);

            .row-item {
                color: white;
            }
        }

        >>>.el-form-item__label {
            color: #4db4f4;
        }

        >>>.el-dialog__title {
            color: #4db4f4;
        }

        >>>.el-dialog__close {
            color: #4db4f4;
        }

        >>>.el-dialog {
            width: 910px;
            height: 630px;
        }

        .cont_list {
            width: 860px;
            height: 425px;
            color: #ffffff;
            font-size: 16px;
            border-radius: 10px;
            margin: 0;
            background-color: rgba(29, 68, 149, 0.1);

            .list_title {
                width: 860px;
                height: 48px;
                background: url(../../../assets/img/per_list_bg.png) no-repeat;
                background-size: 100% 100%;
                @include flex-box(flex-start, center);

                .title_item {
                    height: 48px;
                    @include flex-box(center, center);

                    &:nth-child(1) {
                        width: 300px;
                        margin-right: 2px;
                        margin-left: 30px;
                    }

                    &:nth-child(2) {
                        width: 190px;
                        margin: 0 2px;
                    }

                    &:nth-child(3) {
                        width: 310px;
                        margin: 0 2px;
                    }

                    .select {
                        width: 20px;
                        height: 20px;
                        border: 1px solid #65a6dd;
                        border-radius: 2px;
                        cursor: pointer;
                        @include prefixCss3(transition, border-color 0.2s);

                        &:hover {
                            border-color: #409eff;
                        }

                        &.active {
                            background-color: #409eff;
                            border-color: #409eff;

                            &::after {
                                content: '';
                                display: block;
                                width: 100%;
                                height: 100%;
                                @include set-bg-img('../../../assets/images/icon-yes.png');
                            }
                        }
                    }
                }
            }

            .list_boxes {
                width: 800px;
                height: 375px;
                margin-left: 30px;
                position: relative;
                overflow: hidden;

                .list_box {
                    position: absolute;
                    left: 0;
                    right: -25px;
                    top: 0;
                    bottom: 0;
                    overflow-x: hidden;
                    overflow-y: auto;

                    .box_line {
                        width: 800px;
                        height: 70px;
                        margin: 5px 0 0 0px;
                        border-bottom: 1px dashed #1d4495;
                        @include flex-box(flex-start, center);

                        &:hover {
                            background-color: rgba(49, 88, 128, 0.4);
                        }

                        .list_item {
                            height: 70px;
                            text-align: center;
                            @include flex-box(center, center);

                            &:nth-child(1) {
                                width: 300px;
                                margin-right: 2px;
                            }

                            &:nth-child(2) {
                                width: 200px;
                                margin: 0 2px;
                            }

                            &:nth-child(3) {
                                width: 300px;
                                margin: 0 2px;
                            }

                            .select {
                                width: 20px;
                                height: 20px;
                                border: 1px solid #65a6dd;
                                border-radius: 2px;
                                cursor: pointer;
                                @include prefixCss3(transition, border-color 0.2s);

                                &:hover {
                                    border-color: #409eff;
                                }

                                &.active {
                                    background-color: #409eff;
                                    border-color: #409eff;

                                    &::after {
                                        content: '';
                                        display: block;
                                        width: 100%;
                                        height: 100%;
                                        @include set-bg-img('../../../assets/images/icon-yes.png');
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/ProjectExtend/projectExtendCq2/index.vue